import { ExpFeatures, GlobalSettings, type LicenseEntitlements } from 'common/api/v1/types'
import { PRODUCTS } from 'common/constants'
import { IS_CONNECT_IT } from '../env'

const featureNames: { [k in ExpFeatures]: string } = {
  ExtSelectableDelayMode: 'Choose output delay mode',
  ExtHealthAlarms: 'Health alarms',
  OASResponseValidation: 'OAS response validation',
  AdInsertion: 'Ad Insertion',
  FramerateConversion: 'Frame-rate Conversion',
  ExtPidRemapping: 'PID Remapping',
  ExtUnifiedBilling: 'Unified Billing',
  ExtAlarmKafkaNotifications: 'Alarm Kafka notifications',
  AvcSdiEncoding: 'AVC 4:2:2 SDI Encoding (DEMO)',
  Nmos: 'NMOS',
  AiAssistant: 'AI Assistant',
}

export function getExperimentalDevFeatures(): { name: string; label: string }[] {
  return Object.keys(ExpFeatures)
    .filter((key) => !key.startsWith('Ext'))
    .filter((key) => key !== ExpFeatures.FramerateConversion)
    .filter((key) => !(key === 'AdInsertion' && IS_CONNECT_IT))
    .filter((key) => !(key === ExpFeatures.Nmos && IS_CONNECT_IT))
    .filter((key) => key !== ExpFeatures.AiAssistant)
    .map((key) => ({
      name: key,
      label: featureNames[key as ExpFeatures] || key,
    }))
}

export function getExperimentalExternalFeatures(aiAssistantEntitled: boolean): { name: string; label: string }[] {
  return Object.keys(ExpFeatures)
    .filter((key) => key.startsWith('Ext') || (key === ExpFeatures.AiAssistant && aiAssistantEntitled))
    .map((key) => ({
      name: key,
      label: featureNames[key as ExpFeatures] || key.replace(/^Ext/, ''),
    }))
}

export function isAiAssistantEntitled(entitlements: LicenseEntitlements | undefined): boolean {
  if (!entitlements) return true
  return entitlements.product === PRODUCTS.nimbraEdge.id && entitlements.aiAssistantEnabled !== false
}

export function isFeatureOn(feature: ExpFeatures, settings: GlobalSettings): boolean {
  return !!settings.expFeatures[feature]
}
